import { createProtectedArea } from "@/lib/oa/factories";
import { fetchOOIs } from "@/lib/oa/fetch";
import { shift } from "@/lib/util";
import { useEffect, useState } from "react";

export function useFetchProtectedArea(id: Travelguide.ID | undefined | null) {
  const [data, setData] = useState<Travelguide.POI | undefined>(undefined);

  useEffect(() => {
    if (!id) {
      return;
    }
    fetchOOIs(id).then(createProtectedArea).then(shift).then(setData);
  }, [id]);

  return data;
}
